import { api } from "./api";

export type StorefrontSearchKind =
  | "product"
  | "listing"
  | "store"
  | "pack"
  | "raffle"
  | "auction"
  | "page"
  | "order";

export interface StorefrontSearchItem {
  id: string;
  kind: StorefrontSearchKind;
  title: string;
  subtitle: string;
  path: string;
}

export const STOREFRONT_SEARCH_KIND_LABEL: Record<StorefrontSearchKind, string> = {
  product: "Shop product",
  listing: "Marketplace listing",
  store: "Store",
  pack: "Mystery pack",
  raffle: "Raffle",
  auction: "Auction",
  page: "Page",
  order: "Order",
};

export async function fetchStorefrontSearch(query: string): Promise<StorefrontSearchItem[]> {
  const data = await api<{ items: StorefrontSearchItem[] }>(
    `/storefront/search?q=${encodeURIComponent(query)}`,
  );
  return data.items;
}
